import { ReactElement } from 'react';
import ScreeningAppShell from '@components/screening/layouts/ScreeningAppShell';
import { TalentMap } from './tokens';

export function talentMapLayout(page: ReactElement) {
  return (
    <ScreeningAppShell bleed>
      <TalentMap>{page}</TalentMap>
    </ScreeningAppShell>
  );
}
